const RADIAL_BAR_FILLS = ['#0BA5EC', '#0086C9', '#026AA2'];

export { RADIAL_BAR_FILLS };
